// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606161030/js/" + chunkId + "." + {"44":"99a83270","225":"95e2afe5","481":"add62971","486":"213c985a","770":"97619365"}[chunkId] + ".0.5285067686534195.chunk.js";
};